module.exports = __webpack_public_path__ + "static/media/Event-05.c0801666.svg";